import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  violations: null,
  error: false,
  updateSuccess: false,
  eventGetSuccess: false,
  endError: false,
  startError: false,
  logoUploadSuccess: false,
  logoUploadError: false,
  logoUploading: false,
  event: {}
};

const EventSlice = createSlice({
  name: "Event",
  initialState,
  reducers: {
    eventGetSuccess(state, action) {
      state.event = action.payload
      state.eventGetSuccess = true
    },
    eventGetError(state) {
        state.error = true
    },
    eventUpdateSuccess(state, action) {
      state.event = {
        ...(state.event ?? {}),
        ...action.payload,
      };
      state.updateSuccess = true
    },
    eventUpdateError(state, action) {
      state.violations = action.payload;
      state.error = true;
    },
    eventStartSuccess(state, action) {
      state.event.startAt = action.payload.startAt;
    },
    eventEndSuccess(state, action) {
      state.event.startAt = action.payload.startAt;
    },
    eventEndError(state) {
      state.endError = true;
    },
    eventStartError(state) {
      state.startError = true;
    },
    eventUpdateReset(state) {
      state.violations = null;
      state.error = false;
      state.updateSuccess = false
    },
    logoUploadRequest(state) {
      state.logoUploading = true;
      state.logoUploadSuccess = false;
      state.logoUploadError = false;
      state.violations = null;
    },
    logoUploadSuccess(state, action) {
      state.logoUploading = false;
      state.logoUploadSuccess = true;
      state.logoUploadError = false;
    },
    logoUploadError(state, action) {
      state.logoUploading = false;
      state.logoUploadSuccess = false;
      state.logoUploadError = true;
      state.violations = action.payload;
    },
    logoUploadReset(state) {
      state.logoUploading = false;
      state.logoUploadSuccess = false;
      state.logoUploadError = false;
      state.violations = null;
    },
  },
});

export const {
  eventGetSuccess,
  eventGetError,
  eventUpdateSuccess,
  eventUpdateError,
  eventUpdateReset,
  eventStartSuccess,
  eventStartError,
  eventEndSuccess,
  eventEndError,
  logoUploadRequest,
  logoUploadSuccess,
  logoUploadError,
  logoUploadReset,
} = EventSlice.actions

export default EventSlice.reducer;
